import { useState } from "react";

import { FaInfoCircle } from "react-icons/fa";
import OverlayTrigger, {
	OverlayTriggerProps,
	OverlayTriggerType,
} from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import { Placement } from "@popperjs/core";

import "./styles.scss";

type Props = {
	header?: string;
	message?: string;
	icon?: React.ReactNode;
	children?: React.ReactNode;
	placement?: Placement;
	trigger?: OverlayTriggerType[];
	headerClassName?: string;
	show?: boolean;
	setShow?: (val: boolean) => void;
};

export function CardOverlayTrigger({
	header,
	message,
	placement,
	icon,
	children,
	trigger,
	headerClassName,
	show: externalShow,
	setShow: externalSetShow,
}: Props) {
	const [internalShow, internalSetShow] = useState(false);
	const isControlled = externalShow !== undefined && externalSetShow !== undefined;

	const show = isControlled ? externalShow : internalShow;
	const setShow = isControlled ? externalSetShow : internalSetShow;

	const overlay = (
		<Popover className="custom-popover">
			<Popover.Header as="h3" className={headerClassName ?? ""}>
				{header}
			</Popover.Header>
			<Popover.Body className="fs-8 gap-2">
				<div>{message}</div>
				<div className="text-center">{children}</div>
			</Popover.Body>
		</Popover>
	);

	const overlayTriggerProps: OverlayTriggerProps = {
		overlay: overlay,
		trigger: trigger ?? ["hover", "click"],
		placement: placement ?? "bottom",
		rootClose: true,
		show: isControlled ? show : undefined,
		onToggle: isControlled ? setShow : undefined,
		children: <span>{icon ?? <FaInfoCircle />}</span>,
	};

	return <OverlayTrigger {...overlayTriggerProps} />;
}
